
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhySellHeader from '../components/sections/WhySellHeader';
import ValuesSection from '../components/sections/ValuesSection';
import SellerJourneySection from '../components/sections/SellerJourneySection';
import ComparisonSection from '../components/sections/ComparisonSection';
import AcquisitionFocusSection from '../components/sections/AcquisitionFocusSection';
import ContactCTASection from '../components/sections/ContactCTASection';
import FAQSection from '../components/sections/FAQSection';

const WhySellToNoaPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-noa-antiflash-white dark:bg-noa-rich-black/95">
      <Navbar />
      <main>
        <WhySellHeader />
        <ValuesSection />
        <SellerJourneySection />
        <AcquisitionFocusSection />
        <ComparisonSection />
        <FAQSection />
        <ContactCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default WhySellToNoaPage;
